import React, { Component } from 'react';
import * as contentful from 'contentful';
import { connect } from 'react-redux';

import Header from './components/Header';
import Results from './components/Results';
import Splash from './components/Splash';
import Quiz from './components/Quiz';
import Loader from './components/Loader';

import { updateView, receiveQuestions } from './actions';
import getQueryParameterByName from './utils/getQueryParameterByName';
import { shuffle, chunkArray } from './utils/array';

import items from './data';

import './App.css';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      intro: {},
      questions: [],
      personas: []
    };
  }

  getOverrideQuestions(indexes, questions) {
    const a = indexes.split(',');
    return a.map(index => questions[+index]);
  }

  handleQuizStart() {
    const { dispatch } = this.props;
    dispatch(updateView('quiz'));
  }

  loadAssets(items) {
    // preload the assets
    const preloadItems = [];
    const addToQueue = url => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = e => resolve(img);
        img.onerror = err => reject(err);
        img.src = url;
      });
    }

    if (items) {
      items.forEach(item => {
        preloadItems.push(addToQueue(item));
      });
    }
    
    return new Promise((resolve, reject) => {
      // console.log('[...preloadItems]', [...preloadItems]);
      Promise.all([...preloadItems])
        .then(results => resolve(items))
        .catch(err => reject(err));
    });
  }

  componentDidUpdate(prevProps) {
    const { view: { id }, quiz: { pool } } = this.props;
    if (prevProps.view.id === 'results' && id === 'splash') {
      const chosen = shuffle([...pool[0]]);
      // shuffle and assign id so we can track order
      chosen.forEach(item => {
        const { answer1Long, answer2Long, answer3Long } = item;
        const answers = shuffle([answer1Long, answer2Long, answer3Long].map((answer, index) => Object.assign({}, { text: answer, index })));
        Object.assign(item, { answers });
      });

      // this.loadAssets(themes)
      //   .then(themes => {
      //     this.setState((state, props) => ({
      //       questions: chosen,
      //       themes
      //     }));
      //   })
      //   .catch(err => console.log('Error loading images', err));
    } else if (id === 'results') {
      document.body.style.overflow = 'auto';
    } else if (id !== 'results') {
      document.body.style.overflow = 'hidden';
    }
  }

  componentDidMount() {
    const { dispatch, quiz: { questionsToComplete } } = this.props;
    const client = contentful.createClient({
      space: 'c3rulw0mfm7m',
      environment: 'master',
      accessToken: '3ac46611df65d742d2dbca0b15856713f776eb788b27132f5a5b1641f2bdcefe'
    });
    
    let base = {}, questions = [], archetypes = [], personas = [];
    // items.forEach(({ fields }) => {
    //   if (fields.introSiteTitle) base = fields;
    //   else if (fields.question) questions.push(fields);
    //   else if (fields.archetype) personas.push(fields);
    //   else if (fields.personaNumber) archetypes.push(fields);

    //   const standard = [], beauty = [];
    //   questions.forEach((question, index) => {
    //     const ordered = Object.assign(question, { index });
    //     if (question.questionType === 'beauty') beauty.push(ordered);
    //     else standard.push(ordered);
    //   }); // order matters, capture initial index
    //   const pool = chunkArray(shuffle(standard), questionsToComplete - 1); // -1 so we are able to insert a beauty question
    //   dispatch(receiveQuestions({ pool, beauty }));

    //   const overrideIndexes = getQueryParameterByName('questions');
    //   // const chosen = (overrideIndexes) ? this.getOverrideQuestions(overrideIndexes, questions) : shuffle([...pool[0]/*, beauty[Math.floor(Math.random() * beauty.length)]*/]);
    //   // shuffle and assign id so we can track order
    //   questions.forEach(item => {
    //     const { answer1Long, answer2Long, answer3Long } = item;
    //     const answers = shuffle([answer1Long, answer2Long, answer3Long].map((answer, index) => Object.assign({}, { text: answer, index })));
    //     Object.assign(item, { answers });
    //   });
    //   const personaBgs = [];
    //   archetypes.forEach(item => {
    //     if (item.personaImageMobileUrl) personaBgs.push(item.personaImageMobileUrl);
    //     if (item.personaImageUrl) personaBgs.push(item.personaImageUrl);
    //   });
    //   const questionAssets = [];
    //   questions.forEach(item => {
    //     questionAssets.push(...[item.backgroundDesktop, item.backgroundMobile, item.influencer]);
    //   });
    //   // console.log(questionAssets);

    //   this.loadAssets([...questionAssets, base.introbackgroundImage, base.introBackgroundImageMobileUrl, ...personaBgs])
    //     .then(result => {
    //       this.setState(() => ({
    //         base,
    //         questions,
    //         personas,
    //         archetypes
    //       }));
    //     })
    //     .catch(err => console.log('Error loading images', err));
    // });
    client.getEntries()
      .then(({ items }) => items.forEach(({ fields }) => {
        if (fields.introSiteTitle) base = fields;
        else if (fields.question) questions.push(fields);
        else if (fields.archetype) personas.push(fields);
        else if (fields.personaNumber) archetypes.push(fields);
      }))
      .then(() => {
        const standard = [], beauty = [];
        questions.forEach((question, index) => {
          const ordered = Object.assign(question, { index });
          if (question.questionType === 'beauty') beauty.push(ordered);
          else standard.push(ordered);
        }); // order matters, capture initial index
        const pool = chunkArray(shuffle(standard), questionsToComplete - 1); // -1 so we are able to insert a beauty question
        dispatch(receiveQuestions({ pool, beauty }));

        const overrideIndexes = getQueryParameterByName('questions');
        // const chosen = (overrideIndexes) ? this.getOverrideQuestions(overrideIndexes, questions) : shuffle([...pool[0]/*, beauty[Math.floor(Math.random() * beauty.length)]*/]);
        // shuffle and assign id so we can track order
        questions.forEach(item => {
          const { answer1Long, answer2Long, answer3Long } = item;
          const answers = shuffle([answer1Long, answer2Long, answer3Long].map((answer, index) => Object.assign({}, { text: answer, index })));
          Object.assign(item, { answers });
        });
        const personaBgs = [];
        archetypes.forEach(item => {
          if (item.personaImageMobileUrl) personaBgs.push(item.personaImageMobileUrl);
          if (item.personaImageUrl) personaBgs.push(item.personaImageUrl);
        });
        const questionAssets = [];
        questions.forEach(item => {
          questionAssets.push(...[item.backgroundDesktop, item.backgroundMobile, item.influencer]);
        });
        // console.log(questionAssets);

        this.loadAssets([...questionAssets, base.introbackgroundImage, base.introBackgroundImageMobileUrl, ...personaBgs])
          .then(result => {
            this.setState(() => ({
              base,
              questions,
              personas,
              archetypes
            }));
          })
          .catch(err => console.log('Error loading images', err));
        });
  }

  render() {
    const { base, questions, archetypes, personas } = this.state;
    const { view } = this.props;

    return (
      <div className="App">
        {/* <img style={{position: 'fixed', top: 0, left: 0, width: '100vw', height: 'auto'}} src="./question-left.png" /> */}
        <Header />
        {archetypes === undefined ? <Loader /> : null}
        {archetypes !== undefined && view.id === 'results' ? <Results personas={personas} archetypes={archetypes} base={base} /> : null}
        {archetypes !== undefined ? <Splash {...base} onClick={this.handleQuizStart.bind(this)} /> : null}
        {questions ? <Quiz questions={questions} /> : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    view: state.view,
    quiz: state.quiz
  }
}

App = connect(mapStateToProps)(App);
export default App;



// WEBPACK FOOTER //
// ./src/App.js